import React from 'react';

import styled, { css } from 'canoe/lib/styled';
import { Shortcuts } from 'craft/components/Shortcuts';

interface Props {
  content: string;
  shortcuts?: string[];
}

const Container = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.White};
    line-height: 20px;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    align-items: center;
    font-size: ${theme.fonts.small.fontSize};
  `}
`;

const Content = styled.div<{ withSpace: boolean }>`
  ${({ theme, withSpace }) => css`
    margin-right: ${withSpace ? theme.spaces.xs : '0px'};
  `}
`;

export const TooltipBodyWithShortcuts = ({ content, shortcuts }: Props) => (
  <Container>
    <Content withSpace={!!shortcuts}>{content}</Content>
    {shortcuts && <Shortcuts keys={shortcuts} />}
  </Container>
);
